import {NgModule} from '@angular/core';

import {EditImageModalComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {ImageCardModule} from "../image-card/image-card.module";
import {ImageHeaderModule} from "../image-header/image-header.module";

/**
 * Module for the EditImageModalModule
 * @class
 */
@NgModule({
  declarations: [EditImageModalComponent],
  entryComponents: [EditImageModalComponent],
  exports: [EditImageModalComponent],
  imports: [
    IonicModule,
    ImageCardModule,
    ImageHeaderModule,
  ],
  providers: [],
})
export class EditImageModalModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/edit-image-modal/edit-image-modal.module.ts